import { Component } from 'react';
import {
    EasyFieldComponentProps,
    FormGroupComponentProps,
    FormGroup as FormGroupFormutil
} from 'react-bootstrap-formutil';
import classlist from 'utils/classlist';

/**
 * 项目中存在一些对FormGroup进行二次封装的组件, 为了方便使用, 通常会使用{...restProps}的方式将props传递下去
 * FormGroupComponentProps类型中, 存在一个必传属性是children, 通常情况下, 我们进行二次封装的组件是不需要传递children的; 或者需要传递children, 但只是作为可选属性
 * 但是因为FormGroupComponentProps继承了ColProps类型, 而ColProps又存在{[key: string]: any;}这样的类型定义
 * 就导致我们不能直接使用Omit<FormGroupComponentProps, 'children'>的方式来排除children属性, 这样会让FormGroupComponentProps取到的类型为:
 * {
 *  [x: string]: any;
 *  [x: number]: any;
 * }, 会导致FormGroupComponentProps的类型定义失去了意义
 * 所以我们这里定义一个自定义的FormGroup属性, 使用Pick的方式来获取FormGroupComponentProps中的属性, 以达到我们的目的
 */
type CustomFormGroupProps<T = string> = Omit<EasyFieldComponentProps<T>, 'defaultValue'> &
    Pick<FormGroupComponentProps<T>, 'errorLevel' | 'helper' | 'label' | 'addons'> &
    React.HTMLAttributes<HTMLElement> &
    Partial<Pick<FormGroupComponentProps<T>, 'children' | 'modifyErrorCheck' | 'customCheck'>>;

// bootstrap v5中的FormGroup删除了.form-group类, react-bootstrap v2中的FormGroup也删除了对应的内容
// 为了保证项目的升级前后一致, 这里做一个兼容, 原.form-group类的效果就是加一个margin-bottom: 1rem
class FormGroup<T = string, P = {}, Fields = {}, WeakFields = Fields> extends Component<
    FormGroupComponentProps<T, P, Fields, WeakFields>
> {
    render() {
        const { className, ...restProps } = this.props;

        return <FormGroupFormutil className={classlist('form-group', className)} {...restProps} />;
    }
}

export default FormGroup;
export type { CustomFormGroupProps as FormGroupProps };
